import type { QueryEntity } from '@/sections/insights/queryBuilder/entities/types';

import { adObjectEntity } from './index';

/**
 * ADLocalGroup entity - alias of ADObject
 * Represents Active Directory local group objects
 */
export const adLocalGroupEntity: QueryEntity<unknown> = {
  ...adObjectEntity,
  primaryLabel: { actual: 'ADLocalGroup', display: 'AD Local Group' },
  alias: 'ADObject',
};
